import { Box, Flex } from '@chakra-ui/react';
import { Resizable } from 're-resizable';
import React, { useCallback, useState } from 'react';

import NavigationSidebarContents from '@features/navigation/NavigationSidebarContents';
import {
  NAVIGATION_PANEL_MAX_WIDTH_PX,
  NAVIGATION_PANEL_MIN_WIDTH_PX,
} from 'config/layout/navigationPanel';
import { useBoolean } from 'hooks/useBoolean';

const StickyNavigationSidebar: React.FC = () => {
  const [isResizing, setIsResizing] = useBoolean();
  const [navigationSidebarWidth, setNavigationSidebarWidth] = useState(
    NAVIGATION_PANEL_MIN_WIDTH_PX,
  );

  const setResizedWidth = useCallback(
    ({ widthChange }: { widthChange: number }) => {
      setNavigationSidebarWidth(navigationSidebarWidth + widthChange);
      setIsResizing.off();
    },
    [navigationSidebarWidth, setIsResizing],
  );

  return (
    <Resizable
      minWidth={NAVIGATION_PANEL_MIN_WIDTH_PX}
      maxWidth={NAVIGATION_PANEL_MAX_WIDTH_PX}
      size={{
        width: navigationSidebarWidth,
        height: '100%',
      }}
      onResizeStart={setIsResizing.on}
      onResizeStop={(_evt, _dir, _target, delta) => setResizedWidth({ widthChange: delta.width })}
      enable={{
        top: false,
        right: true,
        bottom: false,
        left: true,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false,
      }}
      style={{
        flexDirection: 'row',
        display: 'flex',
        borderRadius: 'inherit',
      }}
      handleComponent={{
        right: (
          <Box
            position="relative"
            right="-5px"
            height="full"
            // Library has a wrapper around element that has its own hover, this gives priority to our hover animation
            zIndex="banner"
            width={isResizing ? '2px' : '1px'}
            backgroundColor={isResizing ? 'border.dark' : 'border.light'}
            transition="background-color 200ms ease-in, width 100ms ease-in"
            _hover={{
              backgroundColor: 'border.dark',
              width: '2px',
            }}
          />
        ),
      }}
    >
      <Flex
        flexDirection="column"
        overflow="hidden"
        bgColor="sidebar.background"
        role="nav"
        height="full"
        flexGrow={1}
        borderRadius="inherit"
      >
        <NavigationSidebarContents />
      </Flex>
    </Resizable>
  );
};

export default StickyNavigationSidebar;
